import { apiRequest } from './http';
import type { AuditCategory, AuditEntrySummary, InsightsOverview, TemplateUsage } from './types';

export async function getInsightsOverview(): Promise<InsightsOverview> {
  return apiRequest<InsightsOverview>('/api/manage/insights/overview');
}

export async function listTemplateUsage(): Promise<TemplateUsage[]> {
  const response = await apiRequest<{ items?: TemplateUsage[] }>('/api/manage/insights/templates');
  return response.items ?? [];
}

export async function listAuditLog(category?: AuditCategory): Promise<AuditEntrySummary[]> {
  const query = category ? `?category=${encodeURIComponent(category)}` : '';
  const response = await apiRequest<{ items?: AuditEntrySummary[] }>(`/api/manage/audit-log${query}`);
  return response.items ?? [];
}
